import React from 'react'
import { components } from 'cng-web-lib'
import DangerousGoodsFormProperties from './DangerousGoodsFormProperties'
import { Grid, Tooltip } from '@material-ui/core'
import ACEHighwayShipmentTranslationText from '../contexts/ACEHighwayShipmentTranslationText'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'

const {
  button: { CngIconButton }
} = components

const { initialValues } =
  DangerousGoodsFormProperties.formikProps

function DangerousGoodsEntry(props) {
  const {
    index,
    isLast,
    onAddDangerousGoods,
    onDeleteDangerousGoods,
    dangerousGoods,
    showNotification
  } = props

  const aceHighwayShipmentTranslationText = ACEHighwayShipmentTranslationText()
  const naCommonTranslationText = NaCommonTranslationText()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md>
        <DangerousGoodsFormProperties.Fields index={index} showNotification={showNotification} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title={naCommonTranslationText.addNew}>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddDangerousGoods(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title={aceHighwayShipmentTranslationText.cloneButton}>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddDangerousGoods({ ...dangerousGoods, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title={aceHighwayShipmentTranslationText.deleteButton}>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteDangerousGoods(dangerousGoods)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DangerousGoodsEntry
